export const tableDefaultValues = {
  // inverterId: 1,
  buildStatus: 'WAITING_COORDINATES',
  // tableType: 'EDGE',
  // name: '1-CB01-01',
  // epsg2105Easting: 432462.31,
  // epsg2105Northing: 738081.39,
};
